import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import store from "./services/redux/store";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import ErrorBoundary from "./services/ErrorBoundary";
import { CustomLoader } from "./components";
import { CustomThemeProvider } from "./styles/themeContext";
import "./services/I18N/i18n";
const ErrorPage = React.lazy(() => import("./pages/ErrorPage"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary
    fallback={
      <Suspense fallback={<CustomLoader isOpen={true} />}>
        <ErrorPage isGlobal={true} />
      </Suspense>
    }
  >
    <Provider store={store}>
      <CustomThemeProvider>
        <App />
      </CustomThemeProvider>
    </Provider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
